var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialmindBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 1024.001,
    viewBox: "0 0 1200 1024.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 1200,
    height: 1024,
    fill: "#f5f6fa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M834.21,742.572a21.2,21.2,0,0,1,15.036-6.233h21.121a32.219,32.219,0,0,1,62.952,0H939a21.264,21.264,0,0,1,0,42.527H849.235a21.264,21.264,0,0,1-15.025-36.294Z",
    fill: "#edf1fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M447.26,694.425a22.8,22.8,0,0,0-16.245-6.785h-22.86a35.169,35.169,0,0,0-12.176-19.871,34.58,34.58,0,0,0-43.678,0,35.166,35.166,0,0,0-12.177,19.871h-6.139a22.882,22.882,0,0,0-16.252,6.787,23.234,23.234,0,0,0,7.456,37.812,22.8,22.8,0,0,0,8.8,1.761h97.037a22.879,22.879,0,0,0,16.248-6.789,23.291,23.291,0,0,0-.01-32.786Z",
    fill: "#edf1fd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1199,1023.95H0S23.5,796,178,771,281.25,917.5,377.5,917.5,581.445,776.972,694,771,873.911,894.208,941.616,894.208,1018,817,1102,840.5s96.28,143.5,96.28,183.45C1198.53,1024.11,1198.76,1023.83,1199,1023.95Z",
    fill: "#edf1fd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmindBg);
export default __webpack_public_path__ + "static/media/socialmind-bg.337c3cdf2bce7237eb7bd9efad12bc85.svg";
export { ForwardRef as ReactComponent };